import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { createProvider } from "./vue-apollo";

//   "QkWje5aa1Au7ZOdLiITKC3KEiFmaB8DnJvlzuOj4SvUIeECvVJW9tE3eLHXW1JXw"

localStorage.removeItem("apollo-token");

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount("#app");
